import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  workflowCompleteTitle: {
    description: 'Title for the final step in a workflow indicating it is complete',
    defaultMessage: 'Workflow Complete',
    id: 'Gx/LTX',
  },
});
